import { Capacitor } from "@capacitor/core";

export const getVersionId = () =>
  __COMMIT_NUMBER__ + "-" + Capacitor.getPlatform().charAt(0);
